// ============================================================
// TargetsContext - tab list, active target, templates, and
// target-mutation handlers. High update frequency (every wound,
// condition, or tab change) - keep consumers below the provider
// memoized (Phase 3 commit 6).
//
// State itself stays in DeathWatchSimulator's hooks; this context
// only distributes it (composition-root pattern).
// ============================================================
import { createContext, useContext } from 'react';

const TargetsContext = createContext(null);
export default TargetsContext;

export function TargetsProvider({ value, children }) {
  return <TargetsContext.Provider value={value}>{children}</TargetsContext.Provider>;
}

/**
 * Tabs / target state + handlers:
 *   tabs, activeTab, setActiveTab, currentTab, updateTab,
 *   renamingTab, setRenamingTab, dragTab, setDragTab, tabCtx, setTabCtx,
 *   handleTabDrop, handleNewTab, handleCloseTab, handleRenameTab, handleDuplicateTab,
 *   tgtTemplates, showTgtMenu, setShowTgtMenu, newTgtName, setNewTgtName,
 *   handleLoadTgtTemplate, handleSaveTgtTemplate, handleDeleteTgtTemplate,
 *   handleEditArmour, handleAddDefenderMod, handleEditDefenderMod, handleRemoveDefenderMod,
 *   doResetTarget,
 *   rollCharacteristic, rollSkill, rollPlainTarget, rollDiceExpr (defender action sheet)
 *   impactsNow (what just happened to each combatant, by id - the body plates play it)
 */
export function useTargets() {
  const ctx = useContext(TargetsContext);
  if (!ctx) throw new Error('useTargets must be used within a TargetsProvider');
  return ctx;
}
